{
	"ca": {
		"font": "Dades de renda neta per secció censal.",
		"tooltip": {
			"districte": "Districte",
			"seccio": "Secció",
			"rendaNeta": "Renda neta"
		},
		"mapbox": {
			"FullscreenControl.Enter": "Pantalla completa",
			"FullscreenControl.Exit": "Torna",
			"ScrollZoomBlocker.CmdMessage": "Fes ⌘ + scroll per fer zoom al mapa",
			"ScrollZoomBlocker.CtrlMessage": "Fes ctrl + scroll per fer zoom al mapa"
		}
	},
	"es": {
		"font": "Datos de renta neta por sección censal.",
		"tooltip": {
			"districte": "Distrito",
			"seccio": "Sección",
			"rendaNeta": "Renta neta"
		},
		"mapbox": {
			"FullscreenControl.Enter": "Pantalla completa",
			"FullscreenControl.Exit": "Vuelve",
			"ScrollZoomBlocker.CmdMessage": "Usa ⌘ + scroll para hacer zoom en el mapa",
			"ScrollZoomBlocker.CtrlMessage": "Usa ctrl + scroll para hacer zoom en el mapa"
		}
	}
}
